import { billingSlice } from './billing.reducer';

export const {
  setBillingSummary,
  setPaymentSuccess,
  setIsProcessingPayment,
  setTransactionID,
  setIsSummaryExpanded,
  setIsPaymentComplete,
  setActiveAccordion,
  setDisableGiftCard,
  setSelectedPaymentMethods,
  addToSelectedPaymentMethods,
  setKioscoOrderIntent,
  setKioscoOrderIntentError,
  setKioscoStatus,
  addPaymentMethod,
  setPaymentError,
  setGiftCardError,
  setLeavingPayment,
  setIsSignUpModalOpen,
  setIsClubParisModalOpen,
  setIsRemoveClubParisModalOpen,
  setIsGiftCardModalFindItOpen,
  setIsGiftCardModalRemoveOpen,
  setIsCouponModalRemoveOpen,
  setIsNeedInvoiceModalOpen,
  deleteCompany,
  putCompany,
  setIsDeleteCompanyModalOpen,
  setIsInvoiceAndGiftCardAndClubParisModalOpen,
  setIsInvoiceAndGuestModalOpen,
  setIsGiftCardInsufficientModalOpen,
  setIsGiftCardIncompatibleProductsModalOpen,
  setIsGiftCardIncompatibleProductsAllModalOpen,
  setCancelOrderChangePaymentMethod,
  setIsModalQRCencopayVisible,
  setPaymentAvailable,
  setProductsNotCompatibleWithGC,
  setIsKeyboardOpen,
  setIsGenericModalVisible,
  setQRData,
  setCencoPayStatus,
  setIsModalCencopayGetTheAppVisible,
  setIsCencoPayTimeOut,
  setCatMethodEnabled,
  setAvailablePayments,
  setActiveCart,
  setCouponData
} = billingSlice.actions;
